export default function deleteButton(params: any) {

  return `<Button class='btn btn-destructive coaching-form-notes-delete-button'>Delete</Button>`;
};
